import { Component, OnInit } from '@angular/core';
import { TermService } from '../service/term.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-term-of-service-v1-public',
  templateUrl: './term-of-service-v1-public.component.html',
  styleUrls: ['./term-of-service-v1-public.component.css'],
})
export class TermOfServiceV1PublicComponent implements OnInit {
  form: FormGroup;
  constructor(private termService: TermService, private route: Router, private toast: ToastrService) {
    this.form = new FormGroup({
      cpf: new FormControl('', [Validators.required, Validators.minLength(14)]),
      bhirth_date: new FormControl('', [Validators.required, Validators.minLength(10)]),
    });
  }

  ngOnInit(): void {}

  send(accepted: Boolean) {
    confirm(`tem certeza que deseja ${accepted ? 'aceitar' : 'rejeitar'}`);
    const version = 1;

    this.termService
      .acceptByCPF({ ...this.form.value, accepted, version })
      .then((res) => {
        this.toast.success(res.message);
      })
      .catch((err) => {
        console.log(err);

        this.toast.error(err.error.message);
      });
  }
}
